import { create } from 'zustand';
import { supabase } from '../supabase';

interface AuthState {
  user: { id: string } | null;
  profile: { organization_id: string } | null;
  initialized: boolean;
  initialize: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  profile: null,
  initialized: false,

  initialize: async () => {
    if (get().initialized) return;

    const { data: userData } = await supabase.auth.getUser();
    if (!userData?.user) {
      set({ initialized: true });
      return;
    }

    const { data: profileData } = await supabase
      .from('user_profiles')
      .select('organization_id')
      .eq('id', userData.user.id)
      .single();

    set({
      user: { id: userData.user.id },
      profile: profileData ? { organization_id: profileData.organization_id } : null,
      initialized: true,
    });
  },
}));

// Auto-initialize on auth state change
supabase.auth.onAuthStateChange(async (event) => {
  if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
    const store = useAuthStore.getState();
    store.initialize();
  } else if (event === 'SIGNED_OUT') {
    useAuthStore.setState({ user: null, profile: null, initialized: false });
  }
});
